import { render, staticRenderFns } from "./PaperStorage.vue?vue&type=template&id=7dabeac0&scoped=true"
import script from "./PaperStorage.vue?vue&type=script&lang=js"
export * from "./PaperStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dabeac0",
  null
  
)

export default component.exports